import React, { Fragment } from 'react'
import { renderToString } from 'react-dom/server'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Heading from 'components/common/Heading/Heading'
import { generateContent } from './helpers'
import { LazyDiv } from 'components/common/LazyHtml'
import { ToggleLink } from 'components/common/Link/Link'


export const ExpandedPreview = ({
  previewContent: { text, length, title },
  expanded = true,
  toggleOnClick,
  className,
  children
}) =>
  <div className={ className }>
    {
      title && <Heading>{ title }</Heading>
    }
    <LazyDiv
      data-html-block
      content={ generateContent({
        text,
        length,
        expanded,
        component: renderToString(
          <CustomToggleLink
            tabIndex="0"
            role="button"
            aria-expanded={ expanded }>
            { expanded ? 'Read Less' : 'Read More'}
          </CustomToggleLink>)
      }) }
      onClick={ toggleOnClick } />
    {
      expanded && children
    }
  </div>

export const StaticPreview = ({
  children,
  className,
  previewContent: {
    text
  }} = {}
) =>
  <div className={ className }>
    <LazyDiv data-html-block content={ text } />
    { children }
  </div>

StaticPreview.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  previewContent: PropTypes.shape({
    text: PropTypes.string
  })
}

export const TogglablePreview = ({ mobile, ...props }) =>
  mobile ?
    <Fragment>
      <Media.Desktop>
        <StaticPreview { ...props } />
      </Media.Desktop>
      <Media.Mobile>
        <ExpandedPreview { ...props } />
      </Media.Mobile>
    </Fragment> :
    <ExpandedPreview { ...props } />

TogglablePreview.propTypes = {
  mobile: PropTypes.bool
}

ExpandedPreview.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  expanded: PropTypes.bool,
  previewContent: PropTypes.shape({
    length: PropTypes.number,
    text: PropTypes.string,
    title: PropTypes.string
  }),
  toggleOnClick: PropTypes.func
}

const CustomToggleLink = styled(ToggleLink)`
  cursor: pointer;
  margin-left: 5px;
  ${props => props.mobileOnly && css`
    ${Mixin.mobileOnly()}
  `}
`

